import { render } from "./Tasks.vue?vue&type=template&id=4a752219&scoped=true"
import script from "./TasksJs.js?vue&type=script&lang=js"
export * from "./TasksJs.js?vue&type=script&lang=js"

import "./Tasks.vue?vue&type=style&index=0&id=4a752219&lang=css"
import "./Tasks.vue?vue&type=style&index=1&id=4a752219&scoped=true&lang=css"

import exportComponent from "/home/runner/work/veins_practice_vue/veins_practice_vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a752219"]])

export default __exports__